export default __webpack_public_path__ + "static/media/8.c131a3a2.png";